<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);width: 100%;overflow-y: auto">
      <div style="margin: 0 20px">
        <div style="height: 50px">
          <el-button type="primary" plain @click="bindDevice()">绑定设备</el-button>
          <el-input prefix-icon="el-icon-search" placeholder="设备编号 / 设备号码 / 服务对象" v-model="searchKeyword" style="width: 250px" @blur="blurSearch()"></el-input>
          <el-button icon="el-icon-search" type="primary" plain @click="searchWord()">搜索</el-button>
          <el-select v-fixZoom style="width: 110px" v-model="isonline" placeholder="请选择">
            <el-option v-for="item in isonlinearr" :key="item.value" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select v-fixZoom v-model="dtype" style="width: 360px;" multiple placeholder="请选择">
            <el-option v-for="item in dtypearr" :key="item.value" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-button type="success" @click="queryDataTable">查询</el-button>
        </div>
        <div style="max-height: calc(100% - 100px);overflow-y: auto;">
          <el-table v-loading="loading" element-loading-text="加载中，请耐心等待。" :data="showTable" border style="width: 100%" highlight-current-row>
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column label="设备编号" min-width="130" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.devicetype !== 700">
                  {{scope.row.deviceid}}
                </div>
                <div v-else>
                  <el-tooltip placement="top" effect="dark">
                    <div slot="content">
                      <span style="font-size: 14px">版本号：</span>
                      <span style="font-size: 14px">{{scope.row.ver}}</span><br>
                      <span style="font-size: 14px">雷达监测结果：</span>
                      <span style="font-size: 14px" v-if="scope.row.radarstaus === 'tx'">休息</span>
                      <span style="font-size: 14px" v-if="scope.row.radarstaus === 'out'">动作</span><br>
                      <span style="font-size: 14px">雷达监测时间：</span>
                      <span style="font-size: 14px">{{scope.row.radartime}}</span><br>
                    </div>
                    <div>
                      <img style="vertical-align: sub;width: 20px;height: 20px"
                           src="../../../static/tableIcon/lie.png"
                           v-if="scope.row.radarstaus === 'tx'">
                      <img style="vertical-align: sub;width: 20px;height: 20px"
                           src="../../../static/tableIcon/walk.png"
                           v-if="scope.row.radarstaus === 'out'">
                      <span>{{scope.row.deviceid}}</span>
                    </div>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="设备类型" min-width="95" align="center">
              <template slot-scope="scope">
                <span>{{getDeviceType(scope.row.devicetype)}}</span>
              </template>
            </el-table-column>
            <el-table-column label="设备号码" min-width="100" align="center">
              <template slot-scope="scope">
                <span>{{getDevicePhone(scope.row)}}</span>
              </template>
            </el-table-column>
            <el-table-column label="电量" width="60" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.battery}}%</span>
              </template>
            </el-table-column>
            <el-table-column prop="last_online" label="最后在线时间" min-width="140" align="center"></el-table-column>
            <el-table-column label="楼栋/楼层/房间" min-width="140" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.build_name}} / {{scope.row.floor_name}} / {{scope.row.home_room}}</span>
              </template>
            </el-table-column>
            <el-table-column label="安装位置" min-width="75" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.h_installlocation}}</span>
                <span>{{scope.row.o_installlocation}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="p_name" label="服务对象" min-width="80" align="center"></el-table-column>
            <el-table-column align="center" label="操作" width="150">
              <template slot-scope="scope">
                <i v-if="scope.row.devicetype === 602 || scope.row.devicetype === 601 || scope.row.devicetype === 612 || scope.row.devicetype === 613 ||
                scope.row.devicetype === 406 || scope.row.devicetype === 754"
                   style="cursor: pointer; font-size: 18px;color: blue"
                   title="设备设置"
                   class="el-icon-s-tools" @click="setBindPerson(scope.row)"></i>
<!--                <i v-if="scope.row.devicetype === 901" title="微聊" class="el-icon-chat-dot-round" style="cursor: pointer; font-size: 18px;color: #5db713" @click="chatDeviceOpen(scope.row)"></i>-->
                <img v-if="scope.row.devicetype === 300 || scope.row.devicetype === 901 || scope.row.devicetype === 350" src="../../assets/tel/icon_replace.png"
                     title="更换设备"
                     style="width: 14px;vertical-align: baseline;margin-right: 3px;cursor: pointer"
                     @click="openChange(scope.row)">
                <i v-if="getShowMap(scope.row)" title="轨迹" style="cursor: pointer; font-size: 18px;" class="el-icon-delete-location"
                   @click="openTrackMap(scope.row)"></i>
                <i v-if="scope.row.devicetype === 700 || scope.row.devicetype === 901 || scope.row.devicetype === 902 ||
                   scope.row.devicetype === 310 || scope.row.devicetype === 311 || scope.row.devicetype === 312 || scope.row.devicetype === 313 ||
                   scope.row.devicetype === 407 || scope.row.devicetype === 752 || scope.row.devicetype === 330 || scope.row.devicetype === 780"
                   style="cursor: pointer; font-size: 18px;color: blue"
                   title="设备设置"
                   class="el-icon-s-tools" @click="openList(scope.row)"></i>
                <i v-if="!(scope.row.devicetype === 601 || scope.row.devicetype === 602 || scope.row.devicetype === 612 || scope.row.devicetype === 613)" title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editDevice(scope.row)"></i>
                <i title="解绑" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delDevice(scope.row)"></i>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="margin-top: 10px;height: 40px;text-align: center">
          <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                         layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
          </el-pagination>
        </div>
      </div>
    </div>
    <!--  单聊  -->
    <el-dialog :visible.sync="chatOpen" v-if="chatOpen" width="1100px" :close-on-click-modal="false" center class="all-open">
      <chat-device ref="chat" v-model="chatOpen" :chatObj="chatObj"></chat-device>
    </el-dialog>
    <!--更换设备-->
    <el-dialog :visible.sync="changeDeviceShow" v-if="changeDeviceShow" width="600px" :close-on-click-modal="true" center class="all-open">
      <div class="title-top-alarm">
        <div> <span>更换设备</span> </div>
        <div class="line-title"></div>
      </div>
      <div>
        <change-device v-model="changeDeviceShow" :changeObj="changeObj" @getFatherEditDevice="getFatherEditDevice"></change-device>
      </div>
    </el-dialog>
    <!--位置信息-->
    <el-dialog :visible.sync="trackShow" v-if="trackShow" width="900px" :close-on-click-modal="true" top="10vh" class="all-open">
      <div class="title-top-alarm">
        <div><span>位置信息</span></div>
        <div class="line-title"></div>
      </div>
      <div style="height: 550px">
        <track-details v-model="trackShow" :trackDetailsObj="trackObj"></track-details>
      </div>
    </el-dialog>
    <!--绑定、编辑-->
    <el-dialog :title="addEditTitle" :visible.sync="addEditShow" v-if="addEditShow" width="600px" :show-close="true" :close-on-click-modal="false" center>
      <add-edit-device-new :addEditObj="addEditObj" v-model="addEditShow" @updateDevice="updateDevice"></add-edit-device-new>
    </el-dialog>
    <!--子机详情、通讯录设置、语音通知、FM频率设置、SOS呼叫号码...-->
    <el-dialog :title="listTitle" :visible.sync="listShow" v-if="listShow" width="850px" :show-close="true" :close-on-click-modal="false" center>
      <list-tabs v-model="listShow" :listObj="listObj"></list-tabs>
    </el-dialog>
    <!--0-SOS呼叫号码、1-跌倒设置、2-闹钟设置、3-语音设置、4-蓝牙功能、5-定位设置、6-室内定位、7录音上传、8-通讯录设置-->
    <el-dialog :visible.sync="listShow901" v-if="listShow901" width="1200" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div><span>{{ listTitle }}</span></div>
        <div class="line-title"></div>
      </div>
      <list-tabs-cat v-model="listShow901" :listObj="listObj"></list-tabs-cat>
    </el-dialog>
    <!--9-电话本、10-白名单、11-发送消息、12-SOS报警电话、13-310闹钟提醒、14-311|313定时测量心率血氧、15-407 752滞留时长-->
    <el-dialog :visible.sync="listShow310" v-if="listShow310" width="850px" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div><span>{{ listTitle }}</span></div>
        <div class="line-title"></div>
      </div>
      <list-tabs-watch310 v-model="listShow310" :listObj="listObj"></list-tabs-watch310>
    </el-dialog>
    <!--16-330亲情号、17-330白名单、18-330闹钟、19-330定位、20-SOS按键号码、21-780安装高度-->
    <el-dialog :visible.sync="listShowSet" v-if="listShowSet" width="650px" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div><span>{{ listTitle }}</span></div>
        <div class="line-title"></div>
      </div>
      <list-tabs-set v-model="listShowSet" :listObj="listObj"></list-tabs-set>
    </el-dialog>
    <!--  睡眠设置  -->
    <el-dialog :visible.sync="subShow1" v-if="subShow1" width="500px" :show-close="true" :close-on-click-modal="false" center append-to-body class="all-open">
      <div class="title-top-alarm">
        <div> <span>【{{subBedObj.device.deviceid}}】睡眠设置</span> </div>
        <div class="line-title"></div>
      </div>
      <div style="height: 20px"></div>
      <set-sleep :sleepObj="subBedObj" v-model="subShow1"></set-sleep>
    </el-dialog>
  </div>
</template>

<script>
import {
  deletedevicetohome,
  deletedevicetoperson,
  querybinddevice,
  querydevicebyimei,
  searchdevice
} from '../../api/device'
import {queryorgperson} from '../../api/orguser'
import chatDevice from '../../components/datamanagement/deviceComponents/chatDevice'
import changeDevice from '../datamanagement/deviceComponents/changeDevice'
import trackDetails from '../datamanagement/deviceComponents/trackDetails'
import listTabs from '../datamanagement/deviceComponents/listTabs'
import addEditDeviceNew from './components/addEditDeviceNew'
import listTabsCat from '../datamanagement/deviceComponents/listTabsCat'
import {deletedevicenursing, queryorghomepage} from '../../api/yanglaoyuan'
import {queryorg} from '../../api/organizer'
import {queryelderlyhasbed} from '../../api/yanglaoyuan/elderly'
import subDeviceBed from '../datamanagement/childComponents/subDeviceBed.vue'
import setSleep from '../datamanagement/deviceComponents/setSleep.vue'
import listTabsWatch310 from '../datamanagement/deviceComponents/listTabsWatch310.vue'
import listTabsSet from '../datamanagement/deviceComponents/listTabsSet.vue'
export default {
  name: 'deviceOrg',
  components: {
    listTabsSet, listTabsWatch310, setSleep, subDeviceBed, chatDevice, changeDevice, trackDetails, listTabs, addEditDeviceNew, listTabsCat},
  data () {
    return {
      // 左边
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'child',
        label: 'name'
      },
      expandedKeys: [],
      isFirst: [],
      searchKeyword: '',
      tableData: [],
      showTable: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      isonline: 0, // 0常规查询 1在线查询 2离线查询
      isonlinearr: [
        {name: '全部设备', id: 0},
        {name: '在线设备', id: 1},
        {name: '离线设备', id: 2}
      ],
      dtypedown: [], // 搜索接口 导出功能 全部选择
      dtype: [],
      dtypearr: [
        {name: '智能网关', id: 700},
        {name: '手表', id: 300},
        {name: '4G拉绳报警器', id: 902},
        {name: '床头探视终端', id: 851}
      ],
      orgpersons: [],
      // 微聊
      chatOpen: false,
      chatObj: {
        deviceRow: ''
      },
      // 更换设备
      changeDeviceShow: false,
      changeObj: {
        deviceRow: ''
      },
      // 历史轨迹
      trackShow: false,
      trackObj: {
        type: 'device',
        lng: '',
        lat: '',
        deviceRow: ''
      },
      // 设置
      listShow: false,
      listTitle: '',
      listObj: {
        deviceRow: '',
        // lisTabsCat不显示SOS/蓝牙/室内定位
        test: ''
      },
      // 绑定 编辑
      addEditShow: false,
      addEditTitle: '',
      addEditObj: {
        roomArr: [], // 房间
        orgData: [], // 楼层
        orgArr: [], // 组织
        elderly: [], // 服务对象
        isBind: true,
        deviceRow: '',
        isGateway: false,
        radioType: 1 // 1、监护设备页面 - 老人绑定 2、员工设备页面 - 员工绑定
      },
      // 901设置弹窗
      listShow901: false,
      // 设备设置
      listShowSet: false,
      listShow310: false,
      // 睡眠带绑定人
      indexActive: 0,
      subShow1: false,
      subBedObj: {
        isMain: true,
        device: ''
      }
    }
  },
  created () {
    // 700 网关绑定到房间、902 4G拉绳报警器绑定到楼层、300 手表可绑定到老人或者护工
    this.getUserTable()
    this.getDataRoom()
    this.getOrgData()
    this.getOldPersonData()
    this.dtypedown = this.commonType.getDeviceTypeArr()
  },
  methods: {
    // 房间
    getDataRoom () {
      let params = {
        page: 1,
        size: 9999
      }
      queryorghomepage(params).then(res => {
        this.addEditObj.roomArr = res.data.orghomes
      }).catch(() => {})
    },
    // 楼层
    getOrgData () {
      queryorg().then(res => {
        this.addEditObj.orgArr = this.clone(res.data.org)
        let arr = []
        for (let i = 0; i < res.data.org.length; i++) {
          let obj = res.data.org[i]
          if (obj.org_type === 0 || obj.org_type === 1) {
            obj.disabled = true
          } else {
            obj.disabled = false
          }
          arr.push(obj)
        }
        this.getOrTree(arr)
      }).catch(() => {})
    },
    getOrTree (arr) {
      console.log(99, arr)
      // 所属组织
      let lastLevel = 100
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level < lastLevel) {
          lastLevel = arr[i].level
        }
      }
      let treeData = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level === lastLevel) {
          treeData.push(arr[i])
        }
      }
      for (let i = 0; i < treeData.length; i++) {
        const child = this.arrayToNode(arr, treeData[i].id)
        if (child.length !== 0) {
          treeData[i].child = child
        }
      }
      this.addEditObj.orgData = treeData
      console.log('treeData', treeData)
    },
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    // 绑定者（平台人员）
    getUserTable () {
      this.loading = true
      queryorgperson().then(res => {
        this.orgpersons = res.data.orgpersons
        this.queryBindDevice()
      }).catch(() => {
        this.loading = false
      })
    },
    // 服务对象
    getOldPersonData () {
      let data = {
        e_id: this.$store.state.user.LoginResp.entity_id
      }
      queryelderlyhasbed({}, data).then(res => {
        this.addEditObj.elderly = res.data.elderly
      })
    },
    bindDevice () {
      this.addEditTitle = '绑定设备'
      this.addEditObj.isBind = true
      this.addEditObj.deviceRow = ''
      this.addEditShow = true
    },
    blurSearch () {
      this.searchKeyword = this.searchKeyword.replace(/\s*/g, '')
      if (this.searchKeyword === '') {
        this.currentPage = 1
        this.queryBindDevice()
      }
    },
    queryDataTable () {
      this.currentPage = 1
      this.searchKeyword = ''
      this.queryBindDevice()
    },
    searchWord () {
      this.isonline = 0
      this.currentPage = 1
      this.searchWord1()
    },
    searchWord1 () {
      let data = {
        lessdeviceid: this.searchKeyword,
        page: this.currentPage,
        size: this.pageSize,
        dtype: this.dtypedown
      }
      searchdevice(data).then(res => {
        let arr = res.data.devices
        this.totalCells = res.data.cnt
        this.tableData = arr
        this.showTable = []
        this.showTable = arr
      }).catch(() => {})
    },
    // 表格
    queryBindDevice () {
      this.loading = true
      let params = {
        page: this.currentPage,
        size: this.pageSize,
        isonline: this.isonline
      }
      let data = {
        dtype: this.dtype
      }
      querybinddevice(params, data).then(res => {
        let arr = res.data.devices
        this.loading = false
        this.totalCells = res.data.cnt
        this.tableData = arr
        this.showTable = []
        this.showTable = arr
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      if (this.searchKeyword === '') {
        this.queryBindDevice()
      } else {
        this.searchWord1()
      }
    },
    handleCurrentChange (val) {
      this.currentPage = val
      if (this.searchKeyword === '') {
        this.queryBindDevice()
      } else {
        this.searchWord1()
      }
    },
    getFatherEditDevice () {
      // console.log(this.isFirst.length)
      this.currentPage = 1
      this.searchKeyword = ''
      this.queryBindDevice()
    },
    getDeviceType (type) {
      if (type === 700) {
        return '智能网关'
      }
      return this.commonType.getDeviceType(type)
    },
    getDevicePhone (row) {
      if (row.simcardno !== '' && row.simcardno !== '<nil>') {
        return row.simcardno
      } else if (row.p_phone !== '') {
        return row.p_phone
      } else if (row.h_phone !== '') {
        return row.h_phone
      } else if (row.o_phone !== '') {
        return row.o_phone
      }
    },
    getNoneWork (row) {
      let aa = row.p_nonetwork
      if (aa === '1') {
        return '开启'
      } else if (aa === '0') {
        return '关闭'
      } else {
        return aa
      }
    },
    // 微聊
    chatDeviceOpen (row) {
      this.chatObj.deviceRow = row
      this.chatOpen = true
    },
    setBindPerson (row) {
      this.subBedObj.device = row
      this.subShow1 = true
    },
    // 更换设备
    openChange (row) {
      this.changeObj.deviceRow = row
      this.changeDeviceShow = true
    },
    getShowMap (row) {
      return this.commonType.getMapDevice(row.devicetype)
    },
    // 历史轨迹
    openTrackMap (row) {
      this.trackObj.deviceRow = row
      let data = {
        imei: row.deviceid
      }
      querydevicebyimei(data).then(res => {
        this.trackObj.lat = res.data.device.Position.lat
        this.trackObj.lng = res.data.device.Position.lng
        this.trackShow = true
      }).catch(() => {})
      // this.trackShow = true
    },
    // 设置
    openList (row) {
      // 300 2g手表不用加, 350 第三方手表暂时不加定位设置, 351 352 353暂时不加定位设置
      this.listTitle = '【' + row.deviceid + '】' + '设置'
      if (row.devicetype === 351 || row.devicetype === 352 || row.devicetype === 353) {
        this.listTitle = '【' + row.deviceid + '】' + '设置呼叫号码'
      }
      this.listObj.deviceRow = row
      if (row.devicetype === 901 || row.devicetype === 901) {
        this.listShow901 = true
        this.listObj.test = false
      } else if (row.devicetype === 310 || row.devicetype === 311 || row.devicetype === 312 || row.devicetype === 313 ||
        row.devicetype === 407 || row.devicetype === 752 || row.devicetype === 701) {
        this.listShow310 = true
      } else if (row.devicetype === 330 || row.devicetype === 331 || row.devicetype === 780) {
        this.listShowSet = true
      } else { // 351 352 353
        this.listShow = true
      }
    },
    // 编辑设备
    editDevice (row) {
      this.addEditTitle = '编辑设备'
      this.addEditObj.isBind = false
      this.addEditObj.deviceRow = row
      this.addEditShow = true
    },
    // 删除设备
    delDevice (row) {
      let name = row.deviceid
      this.$confirm('此操作将永久解绑该设备【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.endDelDevice(row)
      }).catch(() => {})
    },
    endDelDevice (row) {
      let name = row.deviceid
      this.$confirm('此操作将清除与此设备【' + name + '】有关的所有数据并解绑该设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        if (row.devicetype === 300 || row.devicetype === 310 || row.devicetype === 311 || row.devicetype === 312 || row.devicetype === 313 || row.devicetype === 300 || row.devicetype === 901 || row.devicetype === 350) {
          let data = {
            dids: [row.id]
          }
          deletedevicetoperson(data).then(res => {
            this.searchKeyword = ''
            if (this.tableData.length === 1 && this.currentPage > 1) {
              this.currentPage--
            }
            this.queryBindDevice()
            this.$notify({ title: '成功', message: '删除设备成功', type: 'success', duration: 2000 })
          }).catch(() => {})
        } else if (row.devicetype === 902) {
          let data = {
            did: row.id,
            orgid: row.oid,
            sp_id: row.sp_id
          }
          deletedevicenursing(data).then(res => {
            this.searchKeyword = ''
            if (this.tableData.length === 1 && this.currentPage > 1) {
              this.currentPage--
            }
            this.queryBindDevice()
            this.$notify({ title: '成功', message: '删除设备成功', type: 'success', duration: 2000 })
          }).catch(() => {})
        } else {
          let data = {
            dids: [row.id]
          }
          deletedevicetohome(data).then(res => {
            this.searchKeyword = ''
            if (this.tableData.length === 1 && this.currentPage > 1) {
              this.currentPage--
            }
            this.queryBindDevice()
            this.$notify({ title: '成功', message: '删除设备成功', type: 'success', duration: 2000 })
          }).catch(() => {})
        }
      }).catch(() => {})
    },
    updateDevice () {
      this.searchKeyword = ''
      this.queryBindDevice()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/deviceOrg.vue